module.exports = __webpack_public_path__ + "static/001-c174092aa0591ea145ad75e01474e8ef.jpg";